/**
 * OrbDocTutorialsBeginnerTaskManagerSLDocScreenView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait OrbDocTutorialsBeginnerTaskManagerSLDocScreen
 */

import { useOrbDocTutorialsBeginnerTaskManagerSLDocScreenLogic } from '@/hooks/traits/useOrbDocTutorialsBeginnerTaskManagerSLDocScreenLogic';
import type { OrbDocTutorialsBeginnerTaskManagerSLDocScreenConfig } from '@/hooks/traits/useOrbDocTutorialsBeginnerTaskManagerSLDocScreenLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { OrbDocTutorialsBeginnerTaskManagerSLDocView as OrbDocTutorialsBeginnerTaskManagerSLDocViewEntity } from '@app/shared';
import { OrbDocTutorialsBeginnerTaskManagerSLDocBodyView } from '@/components/traits/OrbDocTutorialsBeginnerTaskManagerSLDocBodyView';
import { OrbDocTutorialsBeginnerTaskManagerSLDocFooterView } from '@/components/traits/OrbDocTutorialsBeginnerTaskManagerSLDocFooterView';
import { OrbDocTutorialsBeginnerTaskManagerSLDocHeaderView } from '@/components/traits/OrbDocTutorialsBeginnerTaskManagerSLDocHeaderView';
import { Stack } from '@almadar/ui/components';
import { UISlotComponent } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';

interface OrbDocTutorialsBeginnerTaskManagerSLDocScreenViewProps {
  config?: Partial<OrbDocTutorialsBeginnerTaskManagerSLDocScreenConfig>;
}

export function OrbDocTutorialsBeginnerTaskManagerSLDocScreenView({ config: propsConfig }: OrbDocTutorialsBeginnerTaskManagerSLDocScreenViewProps) {
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useOrbDocTutorialsBeginnerTaskManagerSLDocScreenLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['OrbDocTutorialsBeginnerTaskManagerSLDocView'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="OrbDocTutorialsBeginnerTaskManagerSL" trait="OrbDocTutorialsBeginnerTaskManagerSLDocScreen">
      <UISlotComponent slot="main" pattern={slotWriter['main'] === 'INIT' ? "stack" : "clear"} sourceTrait="OrbDocTutorialsBeginnerTaskManagerSLDocScreen">{slotWriter['main'] === 'INIT' ? (<Stack direction="vertical" gap="none"><OrbDocTutorialsBeginnerTaskManagerSLDocHeaderView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><OrbDocTutorialsBeginnerTaskManagerSLDocBodyView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><OrbDocTutorialsBeginnerTaskManagerSLDocFooterView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Stack>) : null}</UISlotComponent>
    </TraitScopeProvider>
  );
}

export default OrbDocTutorialsBeginnerTaskManagerSLDocScreenView;
